<template>
  <section id="kelas-iklim">
    <div class="pageInfo bumiKini">
      <div class="coverImg">
        <iframe width='100%' height='100%'
          src='https://greenpeace.rimpangdigital.com'
          frameborder='0' allowfullscreen allow='xr-spatial-tracking'></iframe>
      </div>
      <div class="postcardBackdrop" v-if="postcardOpen"
        v-on:click="postcardOpen = false"></div>
      <div :class="{postCard: true, open: postcardOpen}"
        v-on:click="postcardOpen = true">
        <h4>Pesan Iklim untuk Pak Jokowi</h4>
        <p>Sampaikan pesan keresahanmu akan krisis iklim langsung ke
          Pak Presiden melalui kartu pos khusus dari kami!</p>
        <img src="../assets/postcard/postcard-front.png">
        <router-link to="/beraksi/tenggelam-dalam-diam/postcard"
          class="postcardBtn">Buat Kartu Pos</router-link>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'home',
  components: {},
  data() {
    return {
      postcardOpen: false,
    };
  },
  methods: {
  },
  computed: {
  },
  beforeDestroy() {
    document.body.classList.remove('hideoverflow');
  },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.title = 'Pameran Virtual Mengabarkan Kita Tenggelam - Bumi Butuh Aksi';
    document.body.classList.add('hideoverflow');
    setTimeout(() => {
      this.postcardOpen = true;
    }, 1000);
    setTimeout(() => {
      this.postcardOpen = false;
    }, 4000);
  },
};
</script>

<style scoped lang="scss">
  .pageInfo{
    padding-top: 120vh;
    .coverImg{
      width: 100%;
      height: auto;
      margin: 0 auto;
      display: block;
      position: fixed;
      left: 0; top: 0; right: 0;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      bottom: 0;
    }
    .postcardBackdrop{
      background-color: rgba(0,0,0,.2);
      position: absolute;
      left: 0; right: 0; top: 0; bottom: 0;
      z-index: 8;
    }
    .postCard{
      position: fixed;
      right: 100px; top: 37px;
      // left: 20px; top: 120px;
      width: 300px;
      box-sizing: border-box;
      background-color: #fff;
      border-radius: 5px;
      padding: 24px;
      box-shadow: 2px 2px 6px rgba(0,0,0,.3);
      text-align: center;
      transition: all .3s ease;
      height: 42px;
      overflow: hidden;
      padding-top: 10px;
      z-index: 9;
      @media (max-height: 680px) {
        left: 0; right: 0; top: auto; bottom: 0;
        width: auto;
        border-radius: 5px 5px 0 0;
      }
      &.open{
        height: 382px;
        padding-top: 24px;
      }
      &:hover{
        height: 382px;
        padding-top: 24px;
      }
      h4{
        margin: 0 0 6px;
        font-size: 18px;
      }
      p{
        margin: 0 0 10px;
        font-size: 15px;
        line-height: 1.3;
      }
      img{
        width: 100%;
        height: auto;
        margin: 0 0 16px;
        @media (max-height: 680px) {
          width: 252px;
        }
      }
      .postcardBtn{
        padding: 8px 20px;
        border: none;
        border-radius: 3px;
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;
        transition: all .3s ease;
        background-color: #0b845c;
        text-decoration: none;
        color: #fff;
        display: block;
        &:hover{
          background-color: #006d49;
          box-shadow: 2px 2px 6px rgba(0,0,0,.2);
        }
      }
    }
  }
</style>
